var trim = function trim(str, symbol) {
  if (symbol === void 0) {
    symbol = ' ';
  }
  return str.replace(new RegExp("^\\".concat(symbol, "+|\\").concat(symbol, "+$"), 'g'), '');
};

export { trim as default };
//# sourceMappingURL=index.js.map
